/*  Auth reducer */
import { fromJS } from 'immutable';
import {
  AUTH_ACTION,
  REVOKE_AUTH_ACTION,
  GET_USER_AGENZIE,
  SET_USER_AGENZIA,
  LOCK_USER_AGENZIA,
  UNLOCK_USER_AGENZIA,
  GET_USER_ROLES,
  GET_USER_ACL,
  GET_USER_PROFILES,
  GET_COLLABORATORE_ID,
  BLOCK_ACCESS_CAMPUS,
  USER_NOT_FOUND,
  GET_USER_AGENZIE_FOR_DASHBOARD,
  ERROR_USER_ACL,
  SET_IS_TUTOR,
} from './constants';

const initialState = fromJS({
  isAuthenticated: undefined,
  campusAccessBlocked: false,
  userNotFound: false,
  session: null,
  errorUser: false,
  isTutor: false,
  agenzie: {
    list: null,
    current: null,
    locked: false,
  },
});

function authReducer(state = initialState, action) {
  switch (action.type) {
    case AUTH_ACTION:
      return state.set('isAuthenticated', true).set('session', action.session);
    case REVOKE_AUTH_ACTION:
      return state.set('isAuthenticated', false).set('session', null);
    case BLOCK_ACCESS_CAMPUS:
      return state.set('campusAccessBlocked', true);
    case SET_IS_TUTOR:
      return state.set('isTutor', true);
    case USER_NOT_FOUND:
      return state.set('userNotFound', true);
    case GET_USER_ROLES:
      return state.setIn(['roles', 'list'], action.ruoli);
    case GET_USER_PROFILES:
      return state.setIn(['profiles', 'list'], action.profili);
    case GET_USER_ACL:
      return state.setIn(['ACL', 'list'], action.gruppi);
    case GET_USER_AGENZIE:
      return state
        .setIn(['agenzie', 'list'], action.agenzie)
        .setIn(['agenzie', 'current'], null)
        .setIn(['agenzie', 'locked'], false);
    case GET_USER_AGENZIE_FOR_DASHBOARD:
      return state.setIn(['agenzieForDashboard', 'list'], action.agenzieForDashboard);
    case GET_COLLABORATORE_ID:
      return state.set('collaboratoreId', action.id || false);
    case SET_USER_AGENZIA:
      return state.set('isAuthenticated', true).setIn(['agenzie', 'current'], action.agenzia);
    case LOCK_USER_AGENZIA:
      return state.setIn(['agenzie', 'locked'], true);
    case UNLOCK_USER_AGENZIA:
      return state.setIn(['agenzie', 'locked'], false);
    case ERROR_USER_ACL:
      return state.set('errorUser', true);
    default:
      return state;
  }
}

export default authReducer;



// WEBPACK FOOTER //
// ./app/containers/Auth/reducer.js